import axios from 'axios'
import webapi from '../webapi'

const commonFuncs = {
	getWidgetByMenuId: async function(menuId) {
		let widgets = [];
		await axios.post(webapi.base_api_url + '/System/GetWidgetsByMenuId', {
			menuId
		}).then(res => {
			if (res.status == 200 && res.data.Code == 0) {
				widgets = res.data.Data.List;
			}
		});
		return widgets;
	}
}

export default commonFuncs;
